/**
 * Recurrence options per (promotionType × targetType).
 *
 * Stored on a stack as an RFC-5545 RRULE string. Each menu entry surfaces:
 *   - key:   stable identifier
 *   - label: UI-facing copy
 *   - rrule: a template RRULE (UNTIL appended at purchase time)
 *
 * Type/target combos missing from this map have recurrence disabled.
 */
const NONE = [];

const dailyWeekly = [
  { key: "daily",  label: "Repeat daily",  rrule: "FREQ=DAILY" },
  { key: "weekly", label: "Repeat weekly", rrule: "FREQ=WEEKLY" },
];

const weeklyMonthly = [
  { key: "weekly",  label: "Repeat weekly",  rrule: "FREQ=WEEKLY" },
  { key: "monthly", label: "Repeat monthly", rrule: "FREQ=MONTHLY" },
];

const monthlyQuarterly = [
  { key: "monthly",   label: "Repeat monthly",   rrule: "FREQ=MONTHLY" },
  { key: "quarterly", label: "Repeat quarterly", rrule: "FREQ=MONTHLY;INTERVAL=3" },
];

export const PROMOTION_RECURRENCE_MENUS = Object.freeze({
  businessListing: {
    boost:     dailyWeekly,
    spotlight: dailyWeekly,
    featured:  weeklyMonthly,
    premium:   monthlyQuarterly,
    custom:    weeklyMonthly,
  },
  event: {
    boost:     dailyWeekly,
    spotlight: weeklyMonthly,
    featured:  weeklyMonthly,
    premium:   monthlyQuarterly,
    custom:    weeklyMonthly,
  },
});

export function getRecurrenceOptions(targetType, promotionType) {
  const tMap = PROMOTION_RECURRENCE_MENUS[targetType];
  if (!tMap) return NONE;
  return tMap[promotionType] || NONE;
}
